// extracted by mini-css-extract-plugin
module.exports = {"path":"Spinner_path__2g9jY","circle":"Spinner_circle__fpO3c"};